import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { Lock as LockIcon, Home as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { brandColors } from '../../theme/theme';

/**
 * AgentAccessDenied Component
 * 
 * Displays a professional access denied message when user doesn't have
 * permission to access a specific agent.
 */
const AgentAccessDenied = ({ agentName = 'this agent' }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '70vh',
        p: 3
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 600,
          width: '100%',
          p: 5,
          textAlign: 'center',
          borderTop: `4px solid ${brandColors.secondary}`
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 80,
            height: 80,
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 68, 73, 0.1)',
            mb: 3
          }}
        >
          <LockIcon sx={{ fontSize: 40, color: brandColors.secondary }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            color: brandColors.primary,
            fontWeight: 600,
            mb: 2
          }}
        >
          Access Restricted
        </Typography>

        {/* Message */}
        <Typography
          variant="body1"
          sx={{
            color: brandColors.primary,
            mb: 1,
            opacity: 0.8,
            fontSize: '1.1rem'
          }}
        >
          You don't have permission to access <strong>{agentName}</strong>.
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: brandColors.primary,
            mb: 4,
            opacity: 0.6
          }}
        >
          This feature requires specific access rights. Please contact your administrator
          if you believe you should have access to this agent.
        </Typography>

        {/* Action Button */}
        <Button
          variant="contained"
          size="large"
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
          sx={{
            backgroundColor: brandColors.primary,
            color: brandColors.white,
            px: 4,
            py: 1.5,
            '&:hover': {
              backgroundColor: brandColors.secondary
            }
          }}
        >
          Return to Home
        </Button>

        {/* Help Text */}
        <Box sx={{ mt: 4, pt: 3, borderTop: `1px solid ${brandColors.primary}20` }}>
          <Typography
            variant="caption"
            sx={{
              color: brandColors.primary,
              opacity: 0.5,
              display: 'block'
            }}
          >
            Need access? Contact your Greenlight Analytics administrator.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default AgentAccessDenied;

